import React from 'react';
export function Transition() {
  return <section className="bg-[#1E293B] py-20 px-5 text-center" data-id="element-149">
      <div className="max-w-[780px] mx-auto" data-id="element-150">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-151" />

        <p className="text-[clamp(17px,2.5vw,20px)] leading-[1.75] max-w-[580px] mx-auto mb-7 text-[#94A3B8]" data-id="element-152">
          Si querés fabricar snacks proteicos de nivel profesional{' '}
          <strong className="text-white font-semibold" data-id="element-153">
            de forma rápida, sin ingredientes imposibles y sin vaciar tu tarjeta
          </strong>
          , esta es la herramienta definitiva.
        </p>

        <p className="font-montserrat text-[clamp(30px,5vw,48px)] font-black uppercase tracking-[2px] my-4 text-[#22C55E] [text-shadow:0_0_40px_rgba(34,197,94,0.25)]" data-id="element-154">
          El Método Barrita Pro
        </p>

        <p className="text-sm text-[#94A3B8] font-medium tracking-wider uppercase" data-id="element-155">
          La Base de Datos Más Completa de Nutrición Proteica Casera de
          Argentina
        </p>
      </div>
    </section>;
}